import { Box, Grid } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import {
    Championship,
    Collections,
    RaceControl,
    Round,
    useCollection,
} from "api";
import React from "react";
import { IncidentsReportRace } from "ui/views";

interface IncidentsReportTableProsp {
    roundId: string;
    round: Round;
    championship: Championship;
}

const IncidentsReportTable: React.FC<IncidentsReportTableProsp> = ({
    roundId,
    round,
    championship,
}) => {
    const racesControl = useCollection<RaceControl[]>(
        {
            collection: Collections.RACES_CONTROL,
            where: ["roundId", "==", roundId],
            storeAs: `rcToReport${roundId}`,
        },
        true
    );

    if (racesControl) {
        racesControl.sort(
            (rc1, rc2) => (rc1.raceNumber || 0) - (rc2.raceNumber || 0)
        );
    }

    return (
        <>
            <Grid container spacing={2}>
                {racesControl &&
                    racesControl.length > 0 &&
                    racesControl.map((raceControl) => {
                        return (
                            <Grid key={raceControl.id} item xs={12}>
                                <IncidentsReportRace
                                    raceControl={raceControl}
                                    round={round}
                                    championship={championship}
                                />
                            </Grid>
                        );
                    })}
            </Grid>
            {racesControl && racesControl.length === 0 && (
                <Box
                    width="100%"
                    height="100%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    marginTop={2}
                >
                    <Alert
                        severity="info"
                        variant="outlined"
                        style={{ fontSize: 24 }}
                    >
                        Etapa ainda não realizada
                    </Alert>
                </Box>
            )}
        </>
    );
};

export { IncidentsReportTable };
